export default {
  expenseAppeal: '商家费用申诉创建',
  mallExpenseAppealList: '商城费用申诉列表',
  logisticsExpenseAppeal: '物流费用申诉列表',
  payExpenseAppeal: '支付费用申诉列表',
  payExpenseAppealList: '商城支付申诉列表',
  expenseDetail: '费用申诉详情',
  businessNo: '业务单号',
  billingNo: '计费单号',
  appealType: '申诉类型',
  mallSku: '商城Sku',
  selectTime: '请选择时间',
  appealSubmitTime: '申诉提交时间',
  businessReviewTime: '业务审核时间',
  fromDate: '从某日期',
  toDate: '到某日期',
  exportExcel: '导出Excel',
  appealNo: '申诉单号',
  billingRecordNo: '计费单据号',
  currency: '币种',
  originalAmount: '原金额',
  appealAmount: '申诉金额',
  type: '类型',
  belongBusiness: '所属业务',
  relatedBusinessNo: '相关业务单号',
  generatedTime: '生成时间',
  status: '状态',
  settlementCompletedTime: '结算完成时间',
  operation: '操作',
  details: '详情',
  cancel: '取消',
  exportSuccess: '导出成功',
  exportFailed: '导出失败或无数据',
  appealTypeSelect: '申诉类型',
  orderNo: '申诉单号',
  exportExcelFile: '导出Excel',
  exportFileName: '物流费用申诉管理',
  expenseAppealDetails: '费用申诉详情',
  paymentAppealDetails: '支付申诉详情',
  mallAppealDetails: '商城申诉详情',
  logisticsAppealDetails: '物流申诉详情',
  appealInfo: '申诉信息',
  feeType: '费用类型',
  businessType: '所属业务',
  originalFeeAmount: '原费用金额',
  appealRemark: '申诉备注',
  appealTime: '申诉时间',
  appealMaterials: '申诉上传材料',
  businessAuditInfo: '业务审核信息',
  businessAuditRemark: '业务审核备注',
  businessApprovedAmount: '业务核定金额',
  financeAuditInfo: '财务审核信息',
  financeAuditRemark: '财务审核备注',
  financeApprovedAmount: '财务核定金额',
  auditInfo: '审核记录',
  rejectionInfo: '驳回信息',
  rejectionReason: '驳回原因',
  approvedAmount: '最终核定金额',
  originalFeeAndDocInfo: '原费用及单据信息',
  feeAmount: '费用金额',
  billingTime: '计费时间',
  feeDescription: '费用描述',
  feeRemark: '费用备注',
  objectId: '对象ID',
  objectType: '对象类型',
  authorizationProgress: '授理进度',
  associatedBillingNo: '关联(新产生的)计费单号',
  cancelAppeal: '取消申诉',
  edit: '编辑',
  editAppeal: '编辑申诉',
  submitted: '已通过',
  rejected: '已拒绝',
  confirmed: '已确认',
  completed: '已完成',
  cancelled: '已取消',
  getAppealTypeListFailed: '获取申诉类型列表失败',
  getAppealListFailed: '获取申诉列表失败',
  cancelAppealFailed: '取消失败',
  operationFailed: '操作失败',
  appealAmountPlaceholder: '申诉金额',
  appealDetailTitle: '申诉详情',
  getDetailFailed: '获取详情失败',
  approved: '已通过',
  cancelSuccess: '取消成功',
  editSuccess: '编辑成功',
  editFailed: '编辑失败',
  inputAppealAmount: '请输入申诉金额',
  confirm: '确定',
  logisticsAppealDetailTitle: '物流申诉详情',
  pendingReview: '待审核',
  editAppealSuccess: '编辑申诉成功',
  editAppealFailed: '编辑申诉失败',
  appeal: '申诉',
  merchantExpenseAppeal: '商家费用申诉',
  feeInfo: '费用信息',
  feeBlock: '费用版块',
  selectFeeBlock: '请选择费用板块',
  feeItem: '费用费项',
  selectFeeType: '请选择费用类型',
  billingRecordId: '计费单号',
  inputBillingRecordId: '请输入计费单号',
  feeSubject: '费用/科目',
  amount: '金额',
  feeRelatedInfo: '费用相关信息',
  feeRecordTime: '费用记录时间',
  feeStatus: '费用状态',
  appealStatus: '申诉状态',
  approvedFee: '核定费用',
  businessAuditTime: '业务审核时间',
  financeAuditTime: '财务审核时间',
  settlementTime: '结算时间',
  noFeeTypeInBlock: '该费用版块暂无费用类型',
  getFeeTypeFailed: '获取费用类型失败',
  regionCodeMissing: 'regionCode 参数缺失',
  queryFeeInfoSuccess: '费用信息查询成功',
  queryFailed: '查询失败',
  appealCreateSuccess: '申诉创建成功',
  appealCreateFailed: '创建申诉失败',
  queryFeeInfoFirst: '请先查询费用信息',
  appealAmountTooLarge: '申诉金额不能大于费用金额',
  appealAmountExceedLimit: '申诉金额不能超过 2000',
  appealAmountExceedFeeAmount: '申诉金额不可大于费用金额',
  appealAmountExceedProductAmount: '申诉金额不可大于商品金额',
  // 申诉步骤
  stepSubmitAppeal: '提交申诉',
  stepBusinessReview: '业务审核',
  stepFinanceReview: '财务审核',
  stepSettlement: '结算',
  stepCompleted: '完成',
  stepCancelled: '已取消',
  stepRejected: '已拒绝',
  // 确认操作
  confirmEdit: '确认提交吗？',
  confirmCancelAppeal: '确认取消申诉吗？',
  // 按钮文本
  btnConfirm: '确定',
  btnCancel: '取消',
  // 提示信息
  tips: '温馨提示',
  appealUpdateSuccess: '申诉更新成功',
  appealUpdateFailed: '申诉更新失败',
  fetchDetailFailed: '获取详情失败',
  // 费用状态
  feeStatusCreated: '创建',
  feeStatusConfirmed: '已确认',
  feeStatusBilled: '待结算',
  feeStatusSettled: '已结算',
  feeStatusRefused: '拒绝'
}
